import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';


@Component({
  selector: 'filter-date-time',
  templateUrl: './filter-date-time.component.html',
  styleUrls: ['./filter-date-time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDateTimeComponent),
      multi: true
    }
  ]
})
export class FilterDateTimeComponent implements ControlValueAccessor {

  @Input() set maxDate(value: Date) {
    if(!value) return;
    this._maxDateNgb = {
      day: value.getDate(),
      month: value.getMonth() + 1,
      year: value.getFullYear()
    }
    this._maxDate = value;
  }
  @Input() set minDate(value: Date) {
    if(!value) return;
    this._minDateNgb = {
      day: value.getDate(),
      month: value.getMonth() + 1,
      year: value.getFullYear()
    }
    this._minDate = value;
  }

  public day: dayjs.Dayjs = dayjs();
  public _minDateNgb: NgbDateStruct;
  public _maxDateNgb: NgbDateStruct;
  public _maxDate: Date = null;
  public _minDate: Date = null;

  public dateModalOpen: boolean = false;
  public uiDate: string = '';

  public date: NgbDate;
  public time: Date;

  public popoverOpen: boolean = false;

  private onChange = (_) => {};
  private onTouched= (_) => {};

  constructor(
  ) {}

  public onChangeDate(date: NgbDate) {
    this.date = date;
    this.time = dayjs(this.time).set('date', date.day).set('month', date.month - 1).set('year', date.year).toDate();
    this.buildUiDate();
    this.onChange(this.formatOutput());
  }

  public onChangeTime(time: Date) {
    this.time = time;
    this.buildUiDate();
    this.onChange(this.formatOutput());
  }

  public togglePopover(): void {
    this.popoverOpen = !this.popoverOpen
  }

  public closePopover(): void {
    if(this.popoverOpen) {
      this.popoverOpen = false;
    }
  }

  private formatOutput() {
    if(this.date && this.time) {
      let day = dayjs();
      day = day.set('year', this.date.year)
               .set('month', this.date.month - 1)
               .set('date', this.date.day)
               .set('hour', this.time.getHours())
               .set('minute', this.time.getMinutes())
               .set('second', 0);
      return day.toDate();
    }
  }

  public buildUiDate() {
    if(this.date && this.time) {
      this.uiDate = `${this.date.day}-${this.date.month}-${this.date.year}, ${String(this.time.getHours()).padStart(2, '0')}:${String(this.time.getMinutes()).padStart(2, '0')}`;
    }
  }

  public writeValue(value: string): void {
    if(!value) return;
    this.day = dayjs(value);
    this.date = new NgbDate(this.day.year(), this.day.month() + 1, this.day.date());
    this.time = this.day.toDate();
    this.buildUiDate();
    this.onChange && this.onChange(this.formatOutput());
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
    this.onChange(this.formatOutput());
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }


}
